import React, { useState, useEffect } from 'react';
import { createPortal } from 'react-dom';
import axios from 'axios';
import { API } from '../config';

// Icone social (brand). Cliccando si apre un dialog con l'anteprima della pagina (OpenGraph).
const ICONS = {
  facebook: { color: '#1877F2', path: 'M22 12a10 10 0 10-11.5 9.9v-7H8v-2.9h2.5V9.8c0-2.5 1.5-3.9 3.8-3.9 1.1 0 2.2.2 2.2.2v2.4h-1.2c-1.2 0-1.6.8-1.6 1.5v1.8h2.7l-.4 2.9h-2.3v7A10 10 0 0022 12z' },
  linkedin: { color: '#0A66C2', path: 'M6.94 5a2 2 0 11-4 0 2 2 0 014 0zM7 8.5H3V21h4V8.5zM14.5 8.2c-2 0-3 1.1-3.5 1.9V8.5H7V21h4v-6.8c0-1.8 1.3-2.1 1.8-2.1s1.7.4 1.7 2.1V21h4v-7.4c0-3.5-2-5.4-4-5.4z' },
  twitter: { color: '#0f172a', path: 'M18.9 2H22l-7.6 8.7L23 22h-6.8l-5.3-6.9L4.9 22H2l8.2-9.4L1.5 2h6.9l4.8 6.4L18.9 2zm-1.2 18h1.7L7.1 3.7H5.3L17.7 20z' },
  youtube: { color: '#FF0000', path: 'M23 7.5a3 3 0 00-2.1-2.1C19 5 12 5 12 5s-7 0-8.9.4A3 3 0 001 7.5 31 31 0 001 12a31 31 0 00.1 4.5 3 3 0 002.1 2.1C5 19 12 19 12 19s7 0 8.9-.4A3 3 0 0023 16.5 31 31 0 0023 12a31 31 0 00-.1-4.5zM10 15V9l5 3-5 3z' },
  tiktok: { color: '#0f172a', path: 'M16 3c.3 2 1.5 3.6 3.5 4v2.6c-1.3 0-2.5-.4-3.5-1V15a5.5 5.5 0 11-5.5-5.5c.3 0 .6 0 .9.1v2.7a2.8 2.8 0 102 2.7V3H16z' },
};
const ORDER = ['facebook', 'instagram', 'linkedin', 'twitter', 'youtube', 'tiktok'];
const LABELS = { facebook: 'Facebook', instagram: 'Instagram', linkedin: 'LinkedIn', twitter: 'X', youtube: 'YouTube', tiktok: 'TikTok' };

function Glyph({ name, size }) {
  if (name === 'instagram') {
    return (
      <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke="#E4405F" strokeWidth="2">
        <rect x="2" y="2" width="20" height="20" rx="5" />
        <circle cx="12" cy="12" r="4.5" />
        <circle cx="17.5" cy="6.5" r="1.3" fill="#E4405F" stroke="none" />
      </svg>
    );
  }
  const m = ICONS[name];
  return <svg width={size} height={size} viewBox="0 0 24 24" fill={m.color}><path d={m.path} /></svg>;
}

function PreviewModal({ name, url, onClose }) {
  const [data, setData] = useState(null);
  const [loading, setLoading] = useState(true);
  useEffect(() => {
    let alive = true;
    setLoading(true);
    axios.get(`${API}/indaga/preview`, { params: { url } })
      .then((r) => { if (alive) setData(r.data); })
      .catch(() => { if (alive) setData(null); })
      .finally(() => { if (alive) setLoading(false); });
    return () => { alive = false; };
  }, [url]);

  return createPortal(
    <div onClick={onClose} style={{ position: 'fixed', inset: 0, background: 'rgba(10,10,18,.5)', backdropFilter: 'blur(3px)', zIndex: 13000, display: 'flex', alignItems: 'center', justifyContent: 'center', padding: 20 }}>
      <div onClick={(e) => e.stopPropagation()} style={{ background: 'var(--surface)', borderRadius: 14, width: 380, maxWidth: '94vw', overflow: 'hidden', boxShadow: '0 24px 70px rgba(0,0,0,.4)' }}>
        <div style={{ display: 'flex', alignItems: 'center', gap: 8, padding: '12px 14px', borderBottom: '1px solid #eef2f7' }}>
          <Glyph name={name} size={18} />
          <b style={{ fontSize: 14, color: '#0f172a' }}>{LABELS[name] || name}</b>
          <button onClick={onClose} style={{ marginLeft: 'auto', background: 'none', border: 'none', cursor: 'pointer', color: '#94a3b8', fontSize: 14 }}>✕</button>
        </div>
        {loading ? (
          <div style={{ padding: 28, textAlign: 'center', color: '#94a3b8', fontSize: 13 }}>Carico l'anteprima…</div>
        ) : (
          <>
            {data?.image && (
              <img src={data.image} alt="" onError={(e) => { e.currentTarget.style.display = 'none'; }}
                style={{ width: '100%', maxHeight: 200, objectFit: 'cover', display: 'block' }} />
            )}
            <div style={{ padding: '12px 14px' }}>
              <div style={{ fontSize: 14, fontWeight: 700, color: '#0f172a' }}>{data?.title || 'Anteprima non disponibile'}</div>
              {data?.description && (
                <div style={{ fontSize: 12.5, color: '#475569', marginTop: 4, display: '-webkit-box', WebkitLineClamp: 3, WebkitBoxOrient: 'vertical', overflow: 'hidden' }}>{data.description}</div>
              )}
              <div style={{ fontSize: 11, color: '#94a3b8', marginTop: 6, overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}>{url}</div>
            </div>
          </>
        )}
        <div style={{ padding: '10px 14px', borderTop: '1px solid #eef2f7', display: 'flex', justifyContent: 'flex-end' }}>
          <a className="btn btn-primary" href={url} target="_blank" rel="noreferrer" style={{ textDecoration: 'none' }}>Apri la pagina ↗</a>
        </div>
      </div>
    </div>,
    document.body
  );
}

export default function SocialLinks({ social, size = 18, gap = 8 }) {
  const [preview, setPreview] = useState(null);
  if (!social || typeof social !== 'object') return null;
  const items = ORDER.filter((k) => social[k]);
  if (items.length === 0) return null;
  return (
    <>
      <span style={{ display: 'inline-flex', alignItems: 'center', gap }}>
        {items.map((k) => {
          // Facebook/Instagram bloccano l'anteprima -> aprono diretti; gli altri -> dialog anteprima
          const direct = k === 'facebook' || k === 'instagram';
          if (direct) {
            return (
              <a key={k} href={social[k]} target="_blank" rel="noreferrer" title={LABELS[k] || k} aria-label={k}
                onClick={(e) => e.stopPropagation()}
                style={{ display: 'inline-flex', lineHeight: 0 }}>
                <Glyph name={k} size={size} />
              </a>
            );
          }
          return (
            <button key={k} type="button" title={LABELS[k] || k} aria-label={k}
              onClick={(e) => { e.preventDefault(); e.stopPropagation(); setPreview({ name: k, url: social[k] }); }}
              style={{ display: 'inline-flex', lineHeight: 0, background: 'none', border: 'none', padding: 0, cursor: 'pointer' }}>
              <Glyph name={k} size={size} />
            </button>
          );
        })}
      </span>
      {preview && <PreviewModal name={preview.name} url={preview.url} onClose={() => setPreview(null)} />}
    </>
  );
}
